// These tags shouldn't contain paragraphs within them, so we disable paragraph insertion on them
export const no_paragraph_tags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
// These tags don't have children
export const void_tags = ['MathJax', 'Figure', 'FigureList.Item', 'Image', 'AudioPlayer', 'TaskImageClick', 'TaskSelect', 'area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
// These tags can't be edited directly, and instead open up the text editor for the current panel
export const text_tags = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

// General class describing renderable content. Essentially a wrapper around the "children" array.
export class Content extends Array {
  constructor(...data) {
    super(...data);
    this.type = "Content";
  }
  toJSON() {
    return {
      type: "Content",
      array: [...this]
    };
  }
}

// An Interactive object. Contains metadata and a list of panels.
export class Interactive {
  constructor(attributes) {
    this.type = "Interactive";
    this.title = "Interactive Title";
    this.panels = [new Panel()];
    if (attributes) {
      for (let k in attributes) {
        if (attributes[k] === undefined) delete attributes[k];
      }
    }
    Object.assign(this, attributes);
  }
}

// A Panel object. Contains a list of children. Children can be Components, plain text, or Elements.
export class Panel {
  constructor(attributes) {
    this.type = "Panel";
    this.id = 0;
    this.props = {};
    this.children = new Content();
    if (attributes) {
      for (let k in attributes) {
        if (attributes[k] === undefined) delete attributes[k];
      }
    }
    Object.assign(this, attributes);
  }
}

// A Component object. Contains a tag name and a list of props and children.
// Children can be Components, plain text, or Elements.
// Tasks are components, but we may want to use e.g. React-Bootstrap Rows and Cols as well.
export class Component {
  constructor(attributes) {
    this.type = "Component";
    this.tagName = "InvalidComponent";
    this.props = {};
    if (true || attributes.children) {
      // TODO: Revisit this. Alternatively, add tags to the Void tag list.
      this.children = new Content();
    }
    Object.assign(this, attributes);
  }
}

// An HTML element object. Contains a tag name, props (a.k.a. html element attributes), and a list of children. 
// Children can be Components, plain text, or Elements.
export class Element {
  constructor(attributes) {
    this.type = "Element";
    this.tagName = 'div';
    this.props = {};
    if (true || attributes.children) {
      // TODO: Revisit this. Alternatively, add tags to the Void tag list.
      this.children = new Content();
    }
    Object.assign(this, attributes);
  }
}
export function deepMap(data, fun, key) {
  if (!data) return data;
  if (data.map) {
    return fun(data.map((x, i, a) => {
      return deepMap(x, fun, `${key}-${i}`);
    }), key);
  } else if (typeof data === "object") {
    let obj = {};
    for (const k of Object.keys(data)) {
      obj[k] = deepMap(data[k], fun, `${key}-${k}`);
    }
    return fun(obj, key);
  } else {
    return fun(data, key);
  }
}

// Converts plain old data into DataStructures.
export function hydrate(data) {
  if (data.type === "Interactive") {
    return new Interactive(data);
  } else if (data.type === "Content") {
    return new Content(...data.array);
  } else if (data.type === "Panel") {
    return new Panel(data);
  } else if (data.type === "Component") {
    return new Component(data);
  } else if (data.type === "Element") {
    return new Element(data);
  } else if (data.type) {
    console.error("Unknown data type!", data);
    return "Unknown data type!";
  }
  return data;
}